import React from 'react'

export default () => (
  <svg width="25" height="35" viewBox="0 0 25 35" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M16.2095 34.45H23.4941C23.9474 34.45 24.3149 34.0824 24.3149 33.6291V1.72046C24.3149 1.26717 23.9474 0.899651 23.4941 0.899651H16.2095C15.7562 0.899651 15.3887 1.26717 15.3887 1.72046V33.6291C15.3887 34.0824 15.7562 34.45 16.2095 34.45Z" fill="white"/>
		<path d="M0.820314 34.45H8.10494C8.55822 34.45 8.92574 34.0824 8.92574 33.6291V1.72046C8.92574 1.26717 8.55822 0.899651 8.10494 0.899651H0.820314C0.367029 0.899651 -0.000488281 1.26717 -0.000488281 1.72046V33.6291C-0.000488281 34.0824 0.367029 34.45 0.820314 34.45Z" fill="white"/>
	</svg>
)